export class IAceiteTermoPrivacidade {
  allowEscapeKey: boolean;
  allowOutsideClick: boolean;
  cancelButtonText: string;
  confirmButtonText: string;
  footer: string;
  input: string;
  inputPlaceholder: string;
  inputValidator:Function;
  linkPoliticaPrivacidade:string;
  reverseButtons: boolean;
  showCancelButton: boolean;
  textoCompleto: string;
  textoErroCheckbox: string;
  textoReduzido: string;
  title: string;

  constructor() {}

}



// WEBPACK FOOTER //
// ./src/app/_shared/aceite-termo-privacidade/aceite-termo-privacidade.ts